import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MyCategoriesCoursesComponent } from './my-categories-courses/my-categories-courses.component';
import { DuplicateNodesComponent } from './duplicate-nodes/duplicate-nodes.component';
import { RepositoryComponent } from './repository/repository.component';
import { HelpComponent } from './help/help.component';
import { ContactComponent } from './contact/contact.component';
import { GenerateCourseFormComponent } from './generate-course-form/generate-course-form.component';
import { GenerateCourseFormStartComponent } from './generate-course-form-start/generate-course-form-start.component';
import { GenerateCourseFormSourceComponent } from './generate-course-form-source/generate-course-form-source.component';
import { GenerateCourseFormWikilinksComponent } from './generate-course-form-wikilinks/generate-course-form-wikilinks.component';
import { GenerateCourseFormPdfComponent } from './generate-course-form-pdf/generate-course-form-pdf.component';
import { CourseComponent } from './course/course.component';
import { RefactorTextComponent } from './refactor-text/refactor-text.component';
import { MergeSplitHeadingsComponent } from './merge-split-headings/merge-split-headings.component';
import { SuggestTitleComponent } from './suggest-title/suggest-title.component';
import { ExtractTextWebComponent } from './extract-text-web/extract-text-web.component';
import { GenerateActivitiesTestComponent } from './generate-activities-test/generate-activities-test.component';
import { GenerateGlossaryComponent } from './generate-glossary/generate-glossary.component';
import { RecommendMultimediaComponent } from './recommend-multimedia/recommend-multimedia.component';
import { GenerateImagesComponent } from './generate-images/generate-images.component';
import { ExtractImagesComponent } from './extract-images/extract-images.component';
import { GenerateAudioComponent } from './generate-audio/generate-audio.component';
import { CourseDurationComponent } from './course-duration/course-duration.component';
import { ExportCourseComponent } from './export-course/export-course.component';
import { UnitInfoComponent } from './unit-info/unit-info.component';
import { LessonInfoComponent } from './lesson-info/lesson-info.component';
import { HeadingComponent } from './heading/heading.component';
import { MultimediaComponent } from './multimedia/multimedia.component';
import { TablesComponent } from './tables/tables.component';
import { FilesComponent } from './files/files.component';
import { DiagramComponent } from './diagram/diagram.component';
import { ActivityTestComponent } from './activity-test/activity-test.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { ObjectivesComponent } from './objectives/objectives.component';
import { ReportComponent } from './report/report.component';
import { MoveUnitComponent } from './move-unit/move-unit.component';
import { CheckLinksComponent } from './check-links/check-links.component';
import { NodesTextSearchComponent } from './nodes-text-search/nodes-text-search.component';
import { MultimediaReportComponent } from './multimedia-report/multimedia-report.component';
import { CourseLockComponent } from './course-lock/course-lock.component';
import { CourseFormComponent } from './course-form/course-form.component';
import { GenerateCourseComponent } from './generate-course/generate-course.component';
import { GenerateUnitComponent } from './generate-unit/generate-unit.component';
import { GenerateQuestionsMoodleComponent } from './generate-questions-moodle/generate-questions-moodle.component';
import { UsersComponent } from './users/users.component';
import { UsersPermissionsComponent } from './users-permissions/users-permissions.component';

import { TinymceEditorComponent } from './tinymce-editor/tinymce-editor.component';
import { LogsComponent } from './logs/logs.component';

import { ResizableDirective } from './resizable.directive';

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		LoginComponent,
		MyCategoriesCoursesComponent,
		RepositoryComponent,
		HelpComponent,
		ContactComponent,
		GenerateCourseFormComponent,
		GenerateCourseFormStartComponent,
		GenerateCourseFormSourceComponent,
		GenerateCourseFormWikilinksComponent,
		GenerateCourseFormPdfComponent,
		CourseComponent,
		RefactorTextComponent,
		MergeSplitHeadingsComponent,
		SuggestTitleComponent,
		ExtractTextWebComponent,
		GenerateActivitiesTestComponent,
		GenerateGlossaryComponent,
		RecommendMultimediaComponent,
		ExtractImagesComponent,
		GenerateImagesComponent,
		GenerateAudioComponent,
		DuplicateNodesComponent,
		CourseDurationComponent,
		ExportCourseComponent,
		UnitInfoComponent,
		LessonInfoComponent,
		HeadingComponent,
		MultimediaComponent,
		TablesComponent,
		FilesComponent,
		DiagramComponent,
		ActivityTestComponent,
		GlossaryComponent,
		ObjectivesComponent,
		ReportComponent,
		MoveUnitComponent,
		CheckLinksComponent,
		NodesTextSearchComponent,
		MultimediaReportComponent,
		CourseLockComponent,
		CourseFormComponent,
		GenerateCourseComponent,
		GenerateUnitComponent,
		GenerateQuestionsMoodleComponent,
		UsersComponent,
		UsersPermissionsComponent,

		TinymceEditorComponent,
		LogsComponent,

		ResizableDirective,
	],
	imports: [
		CommonModule,
		BrowserModule,
		AppRoutingModule,
		FormsModule,
		HttpClientModule,
		ReactiveFormsModule,
		DragDropModule,
		BrowserAnimationsModule,
		EditorModule,
		AutocompleteLibModule,
		SweetAlert2Module.forRoot(),
	],
	providers: [
		{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
